import { Icons, Button, notify, HexIcon, tokens } from '@cast/design-system';
import { useMarkSalesContactedMutation } from '@cast/shared-trial-data-access';
import { useTrial, TrialBannerLayout } from '@cast/shared-trial-ui';

import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { openScheduleDialog } from '../../../core/integrations';

export const TrialChangedMindBanner = () => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible } = useTrial();
  const { mutate: markSalesContacted } = useMarkSalesContactedMutation();

  if (!isEligible || !accountReadOnly) {
    return null;
  }

  const handleScheduleCall = () => {
    openScheduleDialog({
      onMeetingBooked: () => {
        markSalesContacted();
      },
      onError: () =>
        notify.error(
          'Failed to load the booking form. Please try again later.'
        ),
    });
  };

  return (
    <TrialBannerLayout
      testId="trial-changed-mind-banner"
      icon={
        <HexIcon
          icon={<Icons.Lightning />}
          size={58}
          iconColor={tokens.theme.fg.status.success}
          hexColor={tokens.theme.data.green400}
        />
      }
      title="Changed your mind?"
      description="Regain access to automated cost optimization, connect unlimited clusters, and secure your infrastructure."
      cta={
        <Button
          startIcon={<Icons.CalendarBlank />}
          onClick={handleScheduleCall}
        >
          Talk to us to upgrade
        </Button>
      }
    />
  );
};
